//*** 公用常量 ***

//1.电话号码格式验证正则表达式**
const telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
//2.身份证号码格式验证正则表达式**
const cardreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
//3.邮箱格式验证正则表达式**
const emailreg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
//4.限中文 **
const testExpress = /[^\u4E00-\u9FA5]/g;
//5.去除html标签
const htmlReg = /<\/?[^>]*>/g;

// 调用token接口时必传参数
const grant_type = 'refresh_token';
const client_id = 'hbzsb-admin';
const client_secret = 'zsb.web.secret';
const themeColor = [
    { "Key": 1, "Name": "黑白灰(默认)", "Style": { "Theme": "#1E1E1E", "MenuSelectedBGColor": "#1f2935", "MenuSelectedText": "#fff", "MenuNotSelectedText": "#fff", "MenuBgColor": "#344154", "headBGColor": "#344154", "headTextColor": "#fff", "IconBGColor": "#344154", "IconTextColor": "#fff", "LogoBGColor": "#344154", "LogoTextColor": "#fff", "Success": "#67c23a", "Warning": "#E6A23C", "Danger": "#F56C6C", "Info": "#909399", "UnderlineColor": "#48494b", "activeUnderlineColor": "#48494b" } },
    { "Key": 2, "Name": "蓝灰色风格", "Style": { "Theme": "#409EFF", "MenuSelectedBGColor": "#FFFFFF", "MenuSelectedText": "#000000", "MenuNotSelectedText": "#000000", "MenuBgColor": "#F7F6F6", "headBGColor": "#297CF4", "headTextColor": "#fff", "IconBGColor": "#1C67D6", "IconTextColor": "#fff", "LogoBGColor": "#1C67D6", "LogoTextColor": "#fff", "Success": "#67c23a", "Warning": "#E6A23C", "Danger": "#F56C6C", "Info": "#909399", "UnderlineColor": "#E8E8E8", "activeUnderlineColor": "#E7E7E7" } },
    { "Key": 3, "Name": "绿灰色风格", "Style": { "Theme": "#009688", "MenuSelectedBGColor": "#FFFFFF", "MenuSelectedText": "#000000", "MenuNotSelectedText": "#000000", "MenuBgColor": "#F7F6F6", "headBGColor": "#64AB41", "headTextColor": "#fff", "IconBGColor": "#599B39", "IconTextColor": "#fff", "LogoBGColor": "#599B39", "LogoTextColor": "#fff", "Success": "#67c23a", "Warning": "#E6A23C", "Danger": "#F56C6C", "Info": "#D3D5D7", "UnderlineColor": "#E8E8E8", "activeUnderlineColor": "#C4C4C5" } },
    { "Key": 4, "Name": "红灰色风格", "Style": { "Theme": "#D94747", "MenuSelectedBGColor": "#FFFFFF", "MenuSelectedText": "#000000", "MenuNotSelectedText": "#000000", "MenuBgColor": "#F7F6F6", "headBGColor": "#FD5252", "headTextColor": "#fff", "IconBGColor": "#EB4B4B", "IconTextColor": "#fff", "LogoBGColor": "#EB4B4B", "LogoTextColor": "#fff", "Success": "#67c23a", "Warning": "#E6A23C", "Danger": "#F56C6C", "Info": "#D3D5D7", "UnderlineColor": "#E8E8E8", "activeUnderlineColor": "#C4C4C5" } }
]
//未设置设置主题色的人员登录用这个默认主题
const defaultThemeStyle = {
    ThemeColor: '#409EFF', //主题色
    SliderMenuColor: '#344154', //菜单背景色
    MenuFontColor: '#FFFFFF', //菜单字体色
    UnderlineColor: '#48494b', //菜单下划线色 动态计算 菜单背景色的浅色
    HeadBgColor: '#344154', //头部背景色
    HeadTextColor: '#FFFFFF', //头部字体色
    Success: "#67C23A",
    Warning: "#E6A23C",
    Danger: "#F56C6C",
    Info: "#909399",
}
// signalR客户端连接地址
const signalRDomain = "http://8.136.215.63:5100"; //测试环境
// const signalRDomain = ishttps == 'http:'?"http://w.huihangedu.cn":"https://w.huihangedu.cn";//生产环境
export {
    telreg,
    cardreg,
    testExpress,
    emailreg,
    htmlReg,
    grant_type,
    client_id,
    client_secret,
    signalRDomain,
    themeColor,
    defaultThemeStyle
}